import React from "react";

export const SelectComponents = (props) => {
  var value;
  if (props.value === true) {
    value = "YES";
  } else if (props.value === false) {
    value = "NO";
  } else if (props.value === null) {
    value = "INDIFFERENT";
  } else {
    value = props.value;
  }
  return (
    <span>
      {console.log("running")}
      {/* {props.value} */}
      {value}
      {value !== undefined ? (
        <i
          className="fa fa-caret-down"
          style={{ marginLeft: 5, color: "gray" }}
        ></i>
      ) : null}
    </span>
  );
};

export default SelectComponents;
